import React, { useCallback, useEffect, useState } from 'react';
import { Phase5ReportToolbar } from './Phase5ReportSystem';
import { readExpandedSections, writeExpandedSections } from '../utils/phase5ReportUi';

// readExpandedSections(sessionId, reportKey) remains available to legacy
// callers; report views intentionally ignore stored open state on reload.

export default function Phase5ReportView({ sessionId, reportName, reportKey, children }) {
  const [sectionIds, setSectionIds] = useState([]);
  // Accordion state is presentation-only.  A new report view always starts
  // with every parent closed; toggles remain available for the current view.
  const [expandedIds, setExpandedIds] = useState([]);

  useEffect(() => { setExpandedIds([]); }, [sessionId, reportKey]);

  const changeExpanded = useCallback((ids) => {
    const unique = [...new Set(ids)];
    setExpandedIds(unique);
    writeExpandedSections(sessionId, reportKey, unique);
  }, [sessionId, reportKey]);

  const registerSections = useCallback((ids) => {
    setSectionIds((current) => current.join('\u0000') === ids.join('\u0000') ? current : ids);
    const available = new Set(ids);
    setExpandedIds((current) => {
      const next = current.filter((id) => available.has(id));
      if (next.join('\u0000') !== current.join('\u0000')) writeExpandedSections(sessionId, reportKey, next);
      return next;
    });
  }, [sessionId, reportKey]);
  const allExpanded = sectionIds.length > 0 && sectionIds.every((id) => expandedIds.includes(id));

  return <>
    <Phase5ReportToolbar reportKey={reportKey} reportName={reportName}
      onExpandAll={() => changeExpanded(sectionIds)} onCollapseAll={() => changeExpanded([])}
      showSectionControls={sectionIds.length > 0}
      expandDisabled={!sectionIds.length || allExpanded}
      collapseDisabled={!sectionIds.length || expandedIds.length === 0} />
    <div data-testid={`report-view-${reportKey}`}>
      {typeof children === 'function'
        ? children({ expandedSectionIds: expandedIds, onExpandedSectionIdsChange: changeExpanded, onSectionIdsChange: registerSections })
        : children}
    </div>
  </>;
}
